import { ChatId } from 'src/app/store/samwin/chats/models/chat-id';

export abstract class Command {
   public constructor(public type: string, public chatId: ChatId) {
      // nothing to do
   }
}

export abstract class CommandWithPayload<TPayload> extends Command {
   public constructor(public type: string, public chatId: ChatId, public payload: TPayload) {
      super(type, chatId);
   }
}
